import { createContext, ReactNode, useContext } from 'react';

interface MessagingThemeContextProps {
  isSidebarTheme: boolean;
}

const MessagingThemeContext = createContext<MessagingThemeContextProps>({
  isSidebarTheme: false,
});

export const MessagingThemeProvider = ({
  children,
  ...props
}: MessagingThemeContextProps & { children: ReactNode }) => (
  <MessagingThemeContext.Provider value={props}>
    {children}
  </MessagingThemeContext.Provider>
);

export const useMessagingTheme = () => {
  const context = useContext(MessagingThemeContext);
  return context;
};
